import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

let supabase;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn('⚠️ PROGETTO IN MODALITÀ ANTEPRIMA (Credenziali: admin@iannata.it / admin123)');
  
  let db = {
    config_v1: {
      id: 'mock-config-1',
      event_title: 'LA IANNATA 2026',
      show_countdown: true,
      show_badge: true,
      show_rules: true,
      show_guests: true,
      event_date: '2026-06-12T21:00',
      global_score_t1: 0,
      global_score_t2: 0,
      badge_gap: 2.5,
      scoreboard_gap: 8,
      gap_badge_title: 4,
      gap_hero_title_countdown: 2,
      gap_score_title_boxes: 4,
      gap_score_box_name_score: 1,
      gap_boxes_partials: 2,
      gap_partials_title_list: 1.5,
      gap_scores_roster: 8,
      gap_title_teams: 5,
      gap_team_header_line: 1.5,
      gap_team_line_captain: 2.5,
      gap_team_captain_grid: 2.5,
      gap_roster_events: 8,
      gap_events_title_grid: 4,
      gap_day_title_events: 2,
      gap_events_list: 1,
      gap_captain_roster: 3,
      page_title: 'IANNATA 2026 | PRO LEAGUE',
      nav_guests: 'GUESTS',
      guests_title: 'SPECIAL GUESTS'
    },
    teams_v1: [
      {
        id: 't1',
        name: 'TEAM <b>ALPHA</b>',
        color: '#E03A3E',
        members: [
          { name: 'Giocatore 1', role: 'Capitano', image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?q=80&w=200&auto=format&fit=crop' },
          { name: 'Giocatore 2', role: 'Active Athlete', image: '' }
        ],
        captain_index: 0,
        division: 'Division A',
        description: 'Alpha Squad Demo'
      },
      {
        id: 't2',
        name: 'TEAM <b>OMEGA</b>',
        color: '#1D428A',
        members: [
          { name: 'Giocatore 3', role: 'Capitano', image: '' },
          { name: 'Giocatore 4', role: 'Active Athlete', image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&auto=format&fit=crop' }
        ],
        captain_index: 0,
        division: 'Division B',
        description: 'Omega Squad Demo'
      }
    ],
    schedule_v1: [
      {
        id: '1',
        day_number: 1,
        title: 'Anteprima Match',
        time: '14:00',
        location: 'Main Arena',
        score_t1: 10,
        score_t2: 8,
        completed: false,
        status: 'upcoming',
        counts_towards_score: true
      }
    ],
    gallery_v1: [],
    rules_v1: [
      {
        id: 'r1',
        title: 'Basket 3v3',
        description: 'Le partite si svolgono a metà campo. La prima squadra che arriva a 21 punti vince,oppure chi è in vantaggio dopo 10 minuti.\nOgni canestro vale 1 punto,da fuori area 2 punti.',
        order_index: 1
      }
    ],
    guests_v1: [
      {
        id: 'g1',
        name: 'Mario Rossi',
        role: 'Event Director',
        description: 'Supervisore generale dell\'evento.',
        image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=200&auto=format&fit=crop',
        order_index: 1
      }
    ]
  };

  let authListener = null;

  const getDummySession = () => {
    const isLogged = sessionStorage.getItem('preview_logged_in') === 'true';
    return isLogged ? { user: { email: 'admin@iannata.it' }, access_token: 'dummy-token' } : null;
  };

  const generateId = () => Math.random().toString(36).substring(2, 15);

  supabase = {
    auth: {
      getSession: async () => ({ data: { session: getDummySession() }, error: null }),
      onAuthStateChange: (callback) => {
        authListener = callback;
        setTimeout(() => callback('SIGNED_IN', getDummySession()), 0);
        return { data: { subscription: { unsubscribe: () => { authListener = null; } } } };
      },
      signInWithPassword: async ({ email, password }) => {
        if (email === 'admin@iannata.it' && password === 'admin123') {
          sessionStorage.setItem('preview_logged_in', 'true');
          const session = { user: { email }, access_token: 'dummy-token' };
          if (authListener) authListener('SIGNED_IN', session);
          return { data: { user: { email }, session }, error: null };
        }
        return { data: { session: null }, error: { message: 'Credenziali anteprima errate' } };
      },
      signOut: async () => {
        sessionStorage.removeItem('preview_logged_in');
        if (authListener) authListener('SIGNED_OUT', null);
        return { error: null };
      }
    },
    from: (table) => ({
      select: () => {
        const chainable = {
          single: async () => {
            if (table === 'config_v1') return { data: db.config_v1, error: null };
            return { data: null, error: null };
          },
          order: () => chainable,
          then: (resolve) => resolve({ data: [...(db[table] || [])], error: null })
        };
        return chainable;
      },
      insert: async (items) => {
        const arr = Array.isArray(items) ? items : [items];
        const newItems = arr.map(item => ({ ...item, id: item.id || generateId() }));
        db[table] = [...(db[table] || []), ...newItems];
        return { error: null };
      },
      update: (updates) => ({
        eq: async (field, value) => {
          if (table === 'config_v1') {
            db.config_v1 = { ...db.config_v1, ...updates };
          } else {
            db[table] = (db[table] || []).map(item => item[field] === value ? { ...item, ...updates } : item);
          }
          return { error: null };
        }
      }),
      delete: () => ({
        eq: async (field, value) => {
          db[table] = (db[table] || []).filter(item => item[field] !== value);
          return { error: null };
        }
      })
    })
  };
} else {
  supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
}

export default supabase;